import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-overlay-spinner',
    templateUrl: './overlay-spinner.component.html',
    styleUrls: ['./overlay-spinner.component.scss'],
    standalone: false
})
export class OverlaySpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
